import { useTranslations } from 'next-intl';
import { Dispatch, SetStateAction } from 'react';

import AuthForm from '../Form/Auth/AuthForm';
import Modal from './Modal';

interface RegisterModalProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onSuccessCallback: () => void;
}

export default function RegisterModal({
  open,
  setOpen,
  onSuccessCallback,
}: RegisterModalProps) {
  const t = useTranslations('Pages.Event.EventPageSelectTicketSection');

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      closeButton={false}
      panelClassName='backdrop-filter backdrop-blur-lg bg-[#101114]/[90]'
      padding='px-4 mb-20 sm:px-8'
    >
      <p className='text-justified my-3 font-bold text-primary-filled-default'>
        {t('registerPromoCodeAdd')}
      </p>
      <AuthForm defaultForm='register' onSuccessCallback={onSuccessCallback} />
    </Modal>
  );
}
